import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import CollectionManager from './CollectionManager';

class ArchiveStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return [];
  }


  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.COLLECTION_ARCHIVED_FETCH:
        CollectionManager.fetchArchived();
        return state;

      case ActionTypes.COLLECTION_ARCHIVED_FETCH_COMPLETE:
        return action.collections;

      default:
        return state;
    }
  }
}

export default new ArchiveStore();
